module.exports = __webpack_public_path__ + "media/images/flags/OM-29edaca621bb39b23e9b5b12377b609a.svg";